import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { style: {"margin-top":"15px"} }
const _hoisted_2 = { class: "mt-3 pt-1" }
const _hoisted_3 = { class: "mt-3 pt-1" }
const _hoisted_4 = ["for"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "d-block ms-2" }, "Active", -1)
const _hoisted_6 = { class: "mt-5" }
const _hoisted_7 = {
  key: 0,
  class: "row no-gutters"
}
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, _mergeProps(_ctx.$attrs, {
    title: _ctx.modalTitle,
    class: "template-modal"
  }), {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", null, [
          _createVNode(_component_AppInput, {
            id: `${_ctx.data?.id}:subject`,
            modelValue: _ctx.submitData.subject,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.submitData.subject) = $event)),
            label: "Subject",
            "input-type": "material"
          }, null, 8, ["id", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_SelectInput, {
            label: "Type",
            options: _ctx.types,
            "field-value": _ctx.typeSelect,
            size: "xl",
            onSelect: _ctx.typesSelectHandler
          }, null, 8, ["options", "field-value", "onSelect"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_AppInput, {
            id: `${_ctx.data?.id}:html`,
            modelValue: _ctx.submitData.html,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.submitData.html) = $event)),
            label: "HTML Code",
            "input-type": "material",
            "is-textarea": true
          }, null, 8, ["id", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            for: `${_ctx.data?.id}:active`,
            class: "d-flex align-items-center cursor-pointer"
          }, [
            _createVNode(_component_AppCheckbox, {
              id: `${_ctx.data?.id}:active`,
              modelValue: _ctx.submitData.isActive,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.submitData.isActive) = $event))
            }, null, 8, ["id", "modelValue"]),
            _hoisted_5
          ], 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.data?.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_AppButton, {
                    loading: _ctx.loading,
                    type: "secondary",
                    size: "xl",
                    onClick: _ctx.submit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Save ")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_AppButton, {
                    loading: _ctx.loading,
                    type: "danger-transparent",
                    size: "xl",
                    onClick: _ctx.remove
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Delete ")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"])
                ])
              ]))
            : (_openBlock(), _createBlock(_component_AppButton, {
                key: 1,
                loading: _ctx.loading,
                type: "secondary",
                size: "xl",
                onClick: _ctx.submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Add template ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
        ])
      ], 32)
    ]),
    _: 1
  }, 16, ["title"]))
}